export default "__VITE_ASSET__4cbcda81__"